/**
 * @open-tender/types is an npm dependency, not workspace-linked, so the new
 * backend fields on the order/check response (estimated_at_adjusted,
 * requested_at_original) can't be added there. This augments the shape
 * locally instead of widening the upstream type.
 */
export interface PrepTimeFields {
  estimated_at: string | null
  estimated_at_adjusted?: boolean
  requested_at_original?: string | null
}

export const getPrepTimeFields = (
  check: PrepTimeFields | null | undefined
): PrepTimeFields | null => {
  if (!check || !check.estimated_at) return null
  return {
    estimated_at: check.estimated_at,
    estimated_at_adjusted: Boolean(check.estimated_at_adjusted),
    requested_at_original: check.requested_at_original ?? null,
  }
}
